import { Link } from 'react-router-dom';

const entries = [
  {
    key: 'tv',
    title: '电视剧',
    desc: '都市 · 悬疑 · 古装 · 家庭，追剧一站直达',
    count: '38+ 部热播剧集',
    path: '/category/tv',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20at%20night%20with%20a%20glowing%20television%20screen%2C%20warm%20red%20accent%20light%20and%20soft%20cushions%2C%20minimal%20editorial%20interior%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=home-entry-tv&orientation=landscape',
  },
  {
    key: 'movie',
    title: '电影',
    desc: '剧情 · 文艺 · 类型片，精选观影参考',
    count: '24+ 部精选影片',
    path: '/category/movie',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20cinema%20hall%20with%20warm%20red%20seats%20and%20a%20softly%20glowing%20screen%2C%20minimal%20atmospheric%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=500&seq=home-entry-movie&orientation=landscape',
  },
];

export default function CategoryEntry() {
  return (
    <section className="px-4 py-12 md:px-8 md:py-14 lg:px-12">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {entries.map((entry) => (
          <Link
            key={entry.key}
            to={entry.path}
            className="group relative h-52 overflow-hidden rounded-lg md:h-64"
          >
            <img
              src={entry.image}
              alt={`${entry.title}分类入口`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/40 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col justify-center p-6 md:p-8">
              <span className="mb-2 w-fit rounded-full bg-background-50/15 px-3 py-1 text-xs text-background-100 backdrop-blur">
                {entry.count}
              </span>
              <h3 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {entry.title}
              </h3>
              <p className="mt-1.5 text-sm text-background-200">{entry.desc}</p>
              <span className="mt-4 inline-flex w-fit items-center gap-1.5 text-sm font-medium text-background-50">
                进入分类
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}